import React from 'react';
import { useMsal } from '@azure/msal-react';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const Header: React.FC = () => {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <header className="bg-white border-b border-gray-200 text-brand-navy shadow-sm">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 bg-brand-red rounded-lg flex items-center justify-center shadow-md text-white">
              <span className="font-bold text-xl font-heading">SF</span>
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight text-brand-navy font-heading">SuccessFactors Migration</h1>
              <p className="text-gray-500 text-sm">Enterprise Data Migration Platform</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-medium text-brand-navy">
                {accounts[0]?.name || 'User'}
              </p>
              <p className="text-xs text-gray-400">
                {accounts[0]?.username || 'user@example.com'}
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <button
                onClick={handleLogout}
                className="p-2 hover:bg-gray-100 text-gray-500 rounded-lg transition-colors"
                title="Log out"
              >
                <LockClosedIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;